/* eslint-disable react/jsx-no-target-blank */
import { plural } from '@cian/utils';
import * as React from 'react';

import { TAreaPartForDesktopSchema } from '../../types/results';
import * as styles from '../AreaParts/AreaParts.css';

export interface IAreaPartsProps {
  areaParts: TAreaPartForDesktopSchema[];
  entityId: number;
  fullUrl: string;
}

export function AreaParts({ areaParts, entityId, fullUrl }: IAreaPartsProps) {
  const areaText = areaParts && plural(areaParts.length - 3, ['площадь', 'площади', 'площадей']);
  const restPartsText = areaParts && `Еще ${areaParts.length - 3} ${areaText}`;

  return (
    areaParts && (
      <div className={styles['row_area_parts']}>
        <ul className={styles['area_parts']}>
          {areaParts.slice(0, 3).map((area, index) => {
            return (
              <li key={`${entityId}-area-part-${index}`} className={styles['area_parts_item']}>
                <a className={styles['area_parts_item_link']} href={`${fullUrl}#/area-parts`} target="_blank">
                  {area.area}
                </a>
                <div className={styles['area_parts_item_price']}>{area.price}</div>
              </li>
            );
          })}
          {areaParts && areaParts.length > 3 && (
            <li className={styles['area_parts_item']}>
              <a className={styles['area_parts_item_link']} href={`${fullUrl}#/area-parts`} target="_blank">
                {restPartsText}
              </a>
            </li>
          )}
        </ul>
      </div>
    )
  );
}
